import React from 'react';
import { Box, Typography } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';

interface ITextStepComponentProps {
  steps: string[];
  variant: 'body1' | 'body2' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  TypographyProps?: any;
  IconProps?: any;
}

const TextStepComponent = ({
  steps,
  variant,
  TypographyProps,
  IconProps,
}: ITextStepComponentProps) => {
  return (
    <Box display="flex" flexDirection={'row'} alignItems="center" ml={1}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <Typography {...TypographyProps} variant={variant} component={'div'}>
            {step}
          </Typography>
          {index < steps.length - 1 && <KeyboardArrowRight {...IconProps} />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default TextStepComponent;
